




















































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Dialog, NavBar, Toast, Icon, ActionSheet } from "vant";
import { getBrowser } from "@/utils/browser";
import store from "@/store";
import headerBar from "@/views/h5-page/header/index.vue"
import * as Sentry from "@sentry/vue";
import { webViewRightButton } from "@/utils/hybirdMethods";
import bus from "@/utils/bus";
import { preloadAgreementPdfs } from "@/views/open-account/utils/resolveAgreementPdf";

const UAParser = require('ua-parser-js');

const browser = getBrowser();

const commonModule = namespace("common");
@Component({
  components: {
    ActionSheet,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
	headerBar
  }
})
export default class App extends Vue {
  @commonModule.Getter("nav_title") nav_title: any;

  isApp = browser.isApp;
  network = true;
  include: any = [];

  userAgent:any = window.navigator.userAgent
  rMsie:any = /(msie\s|trident.*rv:)([\w.]+)/
  rFirefox:any = /(firefox)\/([\w.]+)/
  rOpera:any = /(opera).+version\/([\w.]+)/
  rChrome:any = /(chrome)\/([\w.]+)/
  rSafari:any = /version\/([\w.]+).*(safari)/


  isAndroidApp:any = window.navigator.userAgent.indexOf('Android') > -1;
  isIosApp:any = window.navigator.userAgent.indexOf('iPhone OS') > -1;

  newNavbarPath = ['/register', '/license-agreement', '/register-privacy-policy', '/login-disclaimers', '/register/password-setting']

  isShowActions:boolean = false;
  actionsList:any = []
  get showHeader() {
    return (this as any).$route.meta.showHeader && !this.isApp;
  }
  get PCShow(){
    if((this as any).$route.query.headerShow && (this as any).$route.query.headerShow == 'PC'){
      return false
    }else{
      return true
    }
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  @Watch("$route")
  watchRoute(to, from) {
    // 按需动态缓存
    // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
    //跳转回一级页面时，清除之前所有缓存页面
    if (to.meta.deepth === 0) {
      this.include = [];
    }
    if (to.meta.keepAlive) {
      !this.include.includes(to.name) && this.include.push(to.name);
    }
    // 如果 要 form(离开) 的页面是 keepAlive缓存的，
    // 再根据 deepth 来判断是前进还是后退
    // 如果是后退：
    if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
      const index = this.include.indexOf(from.name);
      index !== -1 && this.include.splice(index, 1);
    }
    
    if(this.isApp){
      const _isOpenAccount = this.$route.path.indexOf('open-account') >= 0;
      const _isHelpCenterNew = this.$route.path.indexOf('/help-center') >= 0;
      const _isHelpCenterNewDetails = this.$route.path.indexOf('/help-center/details') >= 0;
      if(_isOpenAccount || _isHelpCenterNew){
        if(_isOpenAccount){
          webViewRightButton({
            isDisplay: true,
            type: 2
          })
        }
        else if(_isHelpCenterNew){
          if(_isHelpCenterNewDetails){
            webViewRightButton({
              isDisplay: true,
              type: 1,
              share: {
                url: window.location.href
              }
            })
          }else{
            webViewRightButton({
              isDisplay: true,
              type: 2
            })
          }
        }
      }else{
        webViewRightButton({
          isDisplay: false,
          type: 2
        })
      }
    }
  }

  created() {
	let _this = (this as any);
    try {
      _this.initSentryInfo();
    } catch (err) {
      
    }
  _this.pretreatPoorNetwork();
    //处理ios键盘弹起页面被顶起整体上移无法回落问题，
    document.addEventListener(
      "blur",
      event => {
        // 当页面没出现滚动条时才执行，因为有滚动条时，不会出现这问题
        // input textarea 标签才执行，因为 a 等标签也会触发 blur 事件
        if (
          document.documentElement.offsetHeight <=
            document.documentElement.clientHeight &&
          ["input", "textarea"].includes((event.target as any).localName) &&
          !(event.target as any).readOnly
        ) {
          document.body.scrollIntoView(); // 回顶部
        }
      },
      true
    );

    (this as any).$JsBridge.themeDidChange("themeDidChange", function (e) {
      localStorage.setItem('BGColor',JSON.parse(e).status)
      _this.$store.commit("common/SAVE_BGCOLOR", JSON.parse(e).status == 1 ? 'black-theme' : JSON.parse(e).status == 0 ? 'white-theme' : '');
    });

    window.addEventListener("offline", () => {
      Toast(this.$t("common.no_network_tip"));
    });

	_this.$apis.getToolDevice({plateform:'maH5'}).then(res =>{
		const device_no:any = sessionStorage.getItem("device_no")
		if(!device_no){
			if(res.data){
				sessionStorage.setItem("device_no",res.data.device_no)
			}else{
				sessionStorage.setItem("device_no",res.device_no)
			}
		}
	}).catch(()=>{

  })

    // 开户协议 PDF 地址全局预拉，点击时同步 window.open
    preloadAgreementPdfs(_this.$apis).catch(() => {});

	// _this.$apis.getSystemParam({code:'h5_version'}).then(res =>{
	// 	if(res.data){
	// 		sessionStorage.setItem("key",res.data.key)
	// 	}else{
	// 		sessionStorage.setItem("key",res.key)
	// 	}
	// })

  }

  mounted(){

	      const _this = (this as any);
    if(_this.isApp){
      const data = performance.getEntriesByType('resource');
      _this.$JsBridge.callHandler('onResourcesLoadTime', JSON.stringify(data))
    }
		  // _this.getAll();
			_this.getAllNew();
	  // iOS 17 版本异常
    _this.$JsBridge.registerHandler("setInputTextareaAttr",()=>{
      setTimeout(()=>{
        document.querySelectorAll('input').forEach(function(input) {
          input.setAttribute("autocomplete", "off");
          input.setAttribute("autocorrect", "off");
        });
        document.querySelectorAll('textarea').forEach(function(textarea) {
          textarea.setAttribute("autocomplete", "off");
          textarea.setAttribute("autocorrect", "off");
        });
      },250);
    });
    _this.$JsBridge.registerHandler('showService', () => {
      _this.showService();
    })
    bus.$on('showService', () => {
      _this.showService();
    })
  }
  getAllNew(){
	  sessionStorage.setItem("version",'19044.1889');
	  sessionStorage.setItem("network", 'Broadband ');
	  sessionStorage.setItem("device", 'iZtng1gf134zq3Z');
	  sessionStorage.setItem("sysyem",'3');
	  sessionStorage.setItem("clientTypes",'PC');
	  sessionStorage.setItem("key", 'Windows11');
  }




  getAll(){

	  const _this = (this as any);
	  
	  _this.userAgent = window.navigator.userAgent
	  const UAResult = _this.getUAParser(_this.userAgent);
	  // _this.init() // 浏览器信息
	  let { version = '', name = '' } = UAResult.os;
	  if(_this.isAndroidApp){
		  name = 'Android'
	  };
	  if(!name){
		  name = _this.isAndroidApp ? 'Android' : 'iOS'
	  };
	  sessionStorage.setItem("version",`${name} ${version}`);
	  _this.getNetworkType() //网络信息
	  if (_this.isAndroidApp) {
		// if(_this.userAgent.split('(Linux; Android ').length > 1){
		// 	if(_this.userAgent.split('(Linux; Android ')[1].split('; ')[1].indexOf('Build') > 0){
		// 	  sessionStorage.setItem("device",_this.userAgent.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0])
		// 	}else{
		// 	  sessionStorage.setItem("device",_this.userAgent.split('(Linux; Android ')[1].split(') ')[0].split(';')[1].split(' ')[1])
		// 	}
		// }else{

		// }
	    let { model = '', vendor = '' } = UAResult.device;
	    sessionStorage.setItem("device", `${vendor} ${model}`);
	    sessionStorage.setItem("sysyem",'2')
	    sessionStorage.setItem("clientTypes",'APP')
	  } else if (_this.isIosApp) {
		// if(_this.userAgent.split('(iPhone; CPU ').length > 1){
		// 	sessionStorage.setItem("device",_this.userAgent.split('(iPhone; CPU ')[1].split(') ')[0].split('like ')[0])
		// }else{
		// 	// sessionStorage.setItem("device", _this.userAgent)

		// }
		let { model = '', vendor = '' } = UAResult.device;
		sessionStorage.setItem("device", `${vendor} ${model}`);
	    sessionStorage.setItem("sysyem",'1')
	    sessionStorage.setItem("clientTypes",'APP')
	  }else{
	    sessionStorage.setItem("device",'Windows')
	    sessionStorage.setItem("sysyem",'3')
	    sessionStorage.setItem("clientTypes",'PC')
	  }

  }

  // device 调整
  getUAParser(ua){
	  const parser = new UAParser();
	  const result = parser.setUA(ua).getResult();
	  
	  return result;
  }

  // 获取操作系统类型
  browserRedirect() {
    const sUserAgent = navigator.userAgent
    const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
    const isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
    if (isMac) return 'Mac'
    const isUnix = (navigator.platform === 'X11') && !isWin && !isMac
    if (isUnix) return 'Unix'
    const isLinux = (String(navigator.platform).indexOf('Linux') > -1)
    if (isLinux) return 'Linux'
    if (isWin) {
      const isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
      if (isWin2K) return 'Win2000'
      const isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
      if (isWinXP) return 'WinXP'
      const isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
      if (isWin2003) return 'Win2003'
      const isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
      if (isWinVista) return 'WinVista'
      const isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
      if (isWin7) return 'Win7'
      const isWin10 = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1
      if (isWin10) return 'Win10'
    }
    return 'other'
  }



  init() {
	let _this = (this as any)
    let browser:any = ''
    let version:any = ''
    let browserMatch:any = _this.uaMatch(_this.userAgent.toLowerCase())

	if(browserMatch){
		if (browserMatch.browser) {
		  browser = browserMatch.browser
		  version = browserMatch.version
		}
	}else{
		version = '13.0.3'
	}

    sessionStorage.setItem("version",version)
  }

  uaMatch(ua) {
    var match = (this as any).rMsie.exec(ua)
    if (match != null) {
      return {
        browser: 'IE',
        version: match[2] || '0'
      }
    }
    var match = (this as any).rFirefox.exec(ua)
    if (match != null) {
      return {
        browser: match[1] || '',
        version: match[2] || '0'
      }
    }
    var match = (this as any).rOpera.exec(ua)
    if (match != null) {
      return {
        browser: match[1] || '',
        version: match[2] || '0'
      }
    }
    var match = (this as any).rChrome.exec(ua)
    if (match != null) {
      return {
        browser: match[1] || '',
        version: match[2] || '0'
      }
    }
    var match = (this as any).rSafari.exec(ua)
    if (match != null) {
      return {
        browser: match[2] || '',
        version: match[1] || '0'
      }
    }
    if (match != null) {
      return {
        browser: '',
        version: '0'
      }
    }
  }


  getNetworkType() {
  	let match:any = (this as any).userAgent.match(/NetType\/\w+/)
  	let networkStr:any = match ? match[0]:'NetType/other'
      networkStr = networkStr.toLowerCase().replace('nettype/', '');
      let networkType:any = '';
      switch(networkStr) {
          case 'wifi':
              networkType = 'WIFI';
              break;
          case '4g':
              networkType = '4g';
              break;
          case '3g':
              networkType = '3g';
              break;
          case '3gnet':
              networkType = '3g';
              break;
          case '2g':
              networkType = '2g';
              break;
          default:
              networkType = 'WIFI';
      }
  	sessionStorage.setItem("network",networkType)
  }




  handleClickLeft() {
    if ((this as any).$route.meta.backPath) {
     (this as any).$router.push((this as any).$route.meta.backPath);
    } else {
     (this as any).$router.go(-1);
    }
  }

  /**
   * @Description 弱网环境初始化
   * @date 2023/12/18
   * @param
   * @return {void}
   */
  pretreatPoorNetwork(){
    
    let _this = (this as any);
    _this.resetPoorNetworkCounter();
  }

  /**
   * @Description 重置弱网环境
   * @date 2023/12/18
   * @param
   * @return {void}
   */
  resetPoorNetworkCounter(){
    let _this = (this as any);
    _this.$store.commit("network/reset_poor_network_environment_counter");
    _this.$store.commit("network/judge_poor_network_environment_status",false);
  }

  /**
   * @Description 初始化Sentry信息
   * 场景，已登录，但重新刷新页面。
   * @date 2024/2/1
   * @return {void}
   */
  initSentryInfo() {
    const h5userInfo = (this as any).$localstorage.get("h5userInfo");
    if (h5userInfo) {
      // 已登录
      if (h5userInfo.user_id) {
        // 存在user_id
        Sentry.configureScope(scope => {
          scope.setUser({
            user_id: h5userInfo.user_id
          });
        });
      }
    }
  }

  logout(){
    const _this = (this as any);
    Dialog.confirm({
      title: _this.$t('openAccount.t000055'),//这里有个空值，无值在谷歌深色模式 message 会不显示
      message: _this.$t('openAccount.t000135'),
      confirmButtonText: _this.$t('openAccount.t000136'),
    }).then(() => {
      localStorage.removeItem('userInfo');
      sessionStorage.removeItem('userInfo');
      sessionStorage.removeItem('token');
      _this.$router.push({
        path: '/open-account/login'
      });
    }).catch(()=>{

    })

  }

  showService(){
    if((this as any).isShowActions) return;
    (this as any).$apis.getEnum({
      key: 'customerServiceUrlApp,customerServicePhone,customerServiceEmail'
    }).then(data => {
      const service = data.find(item => item.key == 'customerServiceUrlApp');
      const phone = data.find(item => item.key == 'customerServicePhone');
      const email = data.find(item => item.key == 'customerServiceEmail');
      (this as any).actionsList = [
        {type: 'service', text: this.$t('m000024'), ...service },
        {type: 'tel', text: this.$t('openAccount.t000029'), ...phone },
        {type: 'mailto', text: this.$t('openAccount.t000030'), ...email }
      ];
      (this as any).isShowActions = true;
    })
  }
  actionHand(item){
    (this as any).$JsBridge.callHandler('jumpPage', {
      type: 2,
      url: {
        tel: 'callPhone',
        mailto: 'sendEmail'
      }[item.type],
      data: item.value
    })
  }
  openService(e){
    window.open(e.value, '_blank');
  }
}
